(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-activate-account"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const togglePassword = document.getElementById('togglePassword1');
    const passwordField = document.getElementById('passwordField1');
    const eyeOpenPassword = document.getElementById('password-icon-open1');
    const eyeHidePassword = document.getElementById('password-icon-hide1');

    togglePassword.addEventListener('click', function () {
      if (passwordField.type === 'password') {
        passwordField.type = 'text';
        eyeOpenPassword.classList.remove('xo-activate-account__icon-hidden');
        eyeHidePassword.classList.add('xo-activate-account__icon-hidden');
      } else {
        passwordField.type = 'password';
        eyeOpenPassword.classList.add('xo-activate-account__icon-hidden');
        eyeHidePassword.classList.remove('xo-activate-account__icon-hidden');
      }
    });

    // Làm tương tự cho trường mật khẩu xác nhận (confirm password)
    const toggleConfirmPassword = document.getElementById('toggleConfirmPassword1');
    const confirmPasswordField = document.getElementById('confirmPasswordField1');
    const eyeOpenConfirmPassword = document.getElementById('password-confirm-icon-open1');
    const eyeHideConfirmPassword = document.getElementById('password-confirm-icon-hide1');

    toggleConfirmPassword.addEventListener('click', function () {
      if (confirmPasswordField.type === 'password') {
        confirmPasswordField.type = 'text';
        eyeOpenConfirmPassword.classList.remove('xo-activate-account__confirm-icon--hidden');
        eyeHideConfirmPassword.classList.add('xo-activate-account__confirm-icon--hidden');
      } else {
        confirmPasswordField.type = 'password';
        eyeOpenConfirmPassword.classList.add('xo-activate-account__confirm-icon--hidden');
        eyeHideConfirmPassword.classList.remove('xo-activate-account__confirm-icon--hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const togglePassword = document.getElementById('togglePassword');
    const passwordField = document.getElementById('password-input-register');
    const eyeOpenPassword = document.getElementById('password-icon-open');
    const eyeHidePassword = document.getElementById('password-icon-hide');

    togglePassword.addEventListener('click', function () {
      if (passwordField.type === 'password') {
        passwordField.type = 'text';
        eyeOpenPassword.classList.remove('xo-register__password-icon--hidden');
        eyeHidePassword.classList.add('xo-register__password-icon--hidden');
      } else {
        passwordField.type = 'password';
        eyeOpenPassword.classList.add('xo-register__password-icon--hidden');
        eyeHidePassword.classList.remove('xo-register__password-icon--hidden');
      }
    });

    // Làm tương tự cho trường mật khẩu xác nhận (confirm password)
    const toggleConfirmPassword = document.getElementById('toggleConfirmPassword');
    const confirmPasswordField = document.getElementById('confirm-password-input-register');
    const eyeOpenConfirmPassword = document.getElementById('password-confirm-icon-open');
    const eyeHideConfirmPassword = document.getElementById('password-confirm-icon-hide');

    toggleConfirmPassword.addEventListener('click', function () {
      if (confirmPasswordField.type === 'password') {
        confirmPasswordField.type = 'text';
        eyeOpenConfirmPassword.classList.remove('xo-register__password-confirm-icon--hidden');
        eyeHideConfirmPassword.classList.add('xo-register__password-confirm-icon--hidden');
      } else {
        confirmPasswordField.type = 'password';
        eyeOpenConfirmPassword.classList.add('xo-register__password-confirm-icon--hidden');
        eyeHideConfirmPassword.classList.remove('xo-register__password-confirm-icon--hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const togglePassword = document.getElementById('togglePassword2');
    const passwordField = document.getElementById('passwordField2');
    const eyeOpenPassword = document.getElementById('password-icon-open2');
    const eyeHidePassword = document.getElementById('password-icon-hide2');

    togglePassword.addEventListener('click', function () {
      if (passwordField.type === 'password') {
        passwordField.type = 'text';
        eyeOpenPassword.classList.remove('xo-reset-pass__icon-hidden');
        eyeHidePassword.classList.add('xo-reset-pass__icon-hidden');
      } else {
        passwordField.type = 'password';
        eyeOpenPassword.classList.add('xo-reset-pass__icon-hidden');
        eyeHidePassword.classList.remove('xo-reset-pass__icon-hidden');
      }
    });

    // Làm tương tự cho trường mật khẩu xác nhận (confirm password)
    const toggleConfirmPassword = document.getElementById('toggleConfirmPassword2');
    const confirmPasswordField = document.getElementById('confirmPasswordField2');
    const eyeOpenConfirmPassword = document.getElementById('password-confirm-icon-open2');
    const eyeHideConfirmPassword = document.getElementById('password-confirm-icon-hide2');

    toggleConfirmPassword.addEventListener('click', function () {
      if (confirmPasswordField.type === 'password') {
        confirmPasswordField.type = 'text';
        eyeOpenConfirmPassword.classList.remove('xo-reset-pass__confirm-icon--hidden');
        eyeHideConfirmPassword.classList.add('xo-reset-pass__confirm-icon--hidden');
      } else {
        confirmPasswordField.type = 'password';
        eyeOpenConfirmPassword.classList.add('xo-reset-pass__confirm-icon--hidden');
        eyeHideConfirmPassword.classList.remove('xo-reset-pass__confirm-icon--hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
